import React from 'react';
import AryNotSelectableTable from './components/AryNotSelectableTable';
import ArySelectableTable from './components/ArySelectableTable';

const AryBaseTable = ({
  data,
  columns,
  filteredColumnsList,
  pinnedColumnsList,
  noContentBox,
  customNoContent,
  isFlat,
  page,
  pageCount,
  tableSx,
  onHover,
  handleChangeStatistics,
  isTableSelectable,
  isLoading,
  skeletonSettings,
  rowBackgroundCondition,
  selectedTransactions
}) =>
  handleChangeStatistics !== undefined && isTableSelectable ? (
    <ArySelectableTable
      data={data}
      columns={columns}
      noContentBox={noContentBox}
      customNoContent={customNoContent}
      filteredColumnsList={filteredColumnsList}
      pinnedColumnsList={pinnedColumnsList}
      page={page}
      pageCount={pageCount}
      onHover={onHover}
      handleChangeStatistics={handleChangeStatistics}
      isTableSelectable={isTableSelectable}
      isLoading={isLoading}
      rowBackgroundCondition={rowBackgroundCondition}
      selectedTransactions={selectedTransactions}
    />
  ) : (
    <AryNotSelectableTable
      data={data}
      columns={columns}
      filteredColumnsList={filteredColumnsList}
      pinnedColumnsList={pinnedColumnsList}
      noContentBox={noContentBox}
      customNoContent={customNoContent}
      isFlat={isFlat}
      page={page}
      pageCount={pageCount}
      tableSx={tableSx}
      isLoading={isLoading}
      skeletonSettings={skeletonSettings}
      rowBackgroundCondition={rowBackgroundCondition}
      selectedTransactions={selectedTransactions}
      onHover={onHover}
    />
  );
export default AryBaseTable;
